import React from 'react';

import { Dialog } from '@paragon/popup-state';

export function NotOnMobileDialog(props: { featureText: string }) {
  return (
    <Dialog title="Not Available on Mobile" variant="design" cancelText="Close" onCancel="close">
      {props.featureText} Come back on a desktop device to experience the full power of Paragon.
    </Dialog>
  );
}
